// store/campaigns/reducer.ts

import { Reducer } from "redux";
import {
  CampaignActionTypes,
  CampaignState,
  CampaignSummaryDto,
  CampaignDetailDto,
  Pagination,
} from "./types";

export const initialState: CampaignState = {
  list: [],
  pagination: null,
  current: undefined,
  loading: false,
  error: null,
  recipients: [],
  recipientsPagination: null,
  recipLoading: false,
  recipError: null,
  report: undefined,
  events: [],
  eventsPagination: null,
  eventsLoading: false,
  eventsError: null,
};
export const reducer: Reducer<CampaignState> = (state: any = initialState, action: any) => {
  switch (action.type) {
    // ─── LIST ───────────────────────────────────────────
    case CampaignActionTypes.GET_CAMPAIGNS_REQUEST:
      return { ...state, loading: true, error: null };

    case CampaignActionTypes.GET_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload.content,
        pagination: action.payload.pagination,
      };

    case CampaignActionTypes.GET_CAMPAIGNS_ERROR:
      return { ...state, loading: false, error: action.payload };

    // ─── SINGLE ─────────────────────────────────────────
    case CampaignActionTypes.GET_CAMPAIGN_REQUEST:
      return { ...state, loading: true, error: null };

    case CampaignActionTypes.GET_CAMPAIGN_SUCCESS:
      return { ...state, loading: false, current: action.payload };

    case CampaignActionTypes.GET_CAMPAIGN_ERROR:
      return { ...state, loading: false, error: action.payload };

    // ─── CREATE ─────────────────────────────────────────
    case CampaignActionTypes.CREATE_CAMPAIGN_REQUEST:
      return { ...state, loading: true, error: null };

    case CampaignActionTypes.CREATE_CAMPAIGN_SUCCESS:
      return { ...state, loading: false };

    case CampaignActionTypes.CREATE_CAMPAIGN_ERROR:
      return { ...state, loading: false, error: action.payload };

    // ─── UPDATE ─────────────────────────────────────────
    case CampaignActionTypes.UPDATE_CAMPAIGN_REQUEST:
      return { ...state, loading: true, error: null };

    case CampaignActionTypes.UPDATE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        current: action.payload,
        list: state.list.map((c: { id: any; }) =>
          c.id === action.payload.id ? action.payload : c
        ),
      };

    case CampaignActionTypes.UPDATE_CAMPAIGN_ERROR:
      return { ...state, loading: false, error: action.payload };

    // ─── DELETE ─────────────────────────────────────────
    case CampaignActionTypes.DELETE_CAMPAIGN_REQUEST:
      return { ...state, loading: true, error: null };

    case CampaignActionTypes.DELETE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        list: state.list.filter((c: { id: any; }) => c.id !== action.payload.id),
        // if we deleted the “current” one, clear it
        current: state.current?.id === action.payload.id ? undefined : state.current,
      };

    case CampaignActionTypes.DELETE_CAMPAIGN_ERROR:
      return { ...state, loading: false, error: action.payload };

    case CampaignActionTypes.GET_CAMPAIGN_RECIPIENTS_REQUEST:
      return { ...state, recipLoading: true, recipError: null };

    case CampaignActionTypes.GET_CAMPAIGN_RECIPIENTS_SUCCESS:
      return {
        ...state,
        recipLoading: false,
        recipients: action.payload.content,
        recipientsPagination: action.payload.pagination,
      };

    case CampaignActionTypes.GET_CAMPAIGN_RECIPIENTS_ERROR:
      return { ...state, recipLoading: false, recipError: action.payload };

          // Full report
    case CampaignActionTypes.GET_CAMPAIGN_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case CampaignActionTypes.GET_CAMPAIGN_REPORT_SUCCESS:
      return { ...state, loading: false, report: action.payload };
    case CampaignActionTypes.GET_CAMPAIGN_REPORT_ERROR:
      return { ...state, loading: false, error: action.payload };

    // Events
    case CampaignActionTypes.GET_CAMPAIGN_EVENTS_REQUEST:
      return { ...state, eventsLoading: true, eventsError: null };
    case CampaignActionTypes.GET_CAMPAIGN_EVENTS_SUCCESS:
      return {
        ...state,
        eventsLoading: false,
        events: action.payload.content,
        eventsPagination: action.payload.pagination
      };
    case CampaignActionTypes.GET_CAMPAIGN_EVENTS_ERROR:
      return { ...state, eventsLoading: false, eventsError: action.payload };

    default:
      return state;
  }
};

export { reducer as CampaignReducer };
